module.exports = __webpack_public_path__ + "assets/tripadvisor-logo-gs.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/tripadvisor-logo-gs.png
// module id = 1211
// module chunks = 7